import { ConversationalChatContainerModule } from '@klant/conversational/conversational-chat-container/conversational-chat-container.module';
import { KlantConversationalConnectorModule } from '@klant/conversational-connector/klant-conversational-connector.module';
import { KlantConversationalModule } from '@klant/conversational/klant-conversational.module';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ApButtonComponent } from '@ap/button';
import { ApErrorComponent } from '@ap/error';

import { ConversationalLinkModule } from './conversational-link/conversational-link.module';
import { RetailKlantConversationalComponent } from './retail-klant-conversational.component';

@NgModule({
    bootstrap: [RetailKlantConversationalComponent],
    declarations: [RetailKlantConversationalComponent],
    exports: [RetailKlantConversationalComponent],
    imports: [
        ApButtonComponent,
        ApErrorComponent,
        BrowserModule,
        ConversationalChatContainerModule,
        ConversationalLinkModule,
        KlantConversationalConnectorModule,
        KlantConversationalModule
    ]
})
export class RetailKlantConversationalModule {}
